import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled, useTheme } from '@mui/material/styles';

export interface LrToggleButtonOption {
    value: string;
    label: string;
}

interface LrToggleButtonProps {
    value: string;
    options: LrToggleButtonOption[];
    onChange: (value: string) => void;
    disabled?: boolean;
    fullWidth?: boolean;
    className?: string;
}

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    '&:not(.Mui-selected)': {
        backgroundColor: theme.palette.background.paper,
    },
}));

export const LrToggleButton: React.FC<LrToggleButtonProps> = ({
    value,
    options,
    onChange,
    disabled = false,
    fullWidth = false,
    className,
}) => {
    const theme = useTheme();
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={(_e, newValue) => {
                if (newValue !== null) onChange(newValue);
            }}
            disabled={disabled}
            fullWidth={fullWidth}
            className={className}
        >
            {options.map((option) => (
                <StyledToggleButton key={option.value} value={option.value} aria-label={option.label}>
                    {option.label}
                </StyledToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default LrToggleButton;
